module Meevo.Plugins.YieldManagementProgram {

    import IBusinessInfoDataService = Meevo.Components.Common.IBusinessInfoDataService;
    import WeekdayNameEnum = Meevo.Model.WeekdayNameEnum;
    import Utilities = Meevo.Components.Common.Utilities;

    class DayTimeAdjustments implements ng.IComponentController {
        static $inject = [
            'meevo.components.common.BusinessInfoDataService',
            '$scope',
            'meevo.components.common.IdentityService',
        ];

        result: IDayTimeAdjustmentsRow[];
        model: ng.INgModelController;
        disabled: boolean;
        isCO: boolean;
        isOwner: boolean;
        initialAdjustments: ProgramTimeRange[];
        modelValue: ProgramTimeRange[];
        program: YMProgramModel;

        constructor(private businessInfoService: IBusinessInfoDataService,
                    private $scope: ng.IScope,
                    private identityService: Meevo.Components.Common.IIdentityService) {
            this.initialAdjustments = [];
        }

        $onInit() {
            this.isCO = this.identityService.inCentralOfficeMode() || this.identityService.isSingleLocation();
            this.isOwner = Utilities.defaultIfNothing(this.isOwner, true);

            this.$scope.$watch(() => this.model.$viewValue, (newValue) => {
                if (newValue instanceof Array) {
                    this.initialAdjustments = [...newValue];
                    this.modelValue = newValue;

                    this.resetResult();
                    this.updateViewValue();
                }
            });

            this.model.$validators.adjustments = (modelValue: ProgramTimeRange[]) => {
                if (!this.result) return true;

                return this.result
                    .map((row) => {
                        return row
                            .adjustments
                            .map((programTimeRange: ProgramTimeRange) => {
                                programTimeRange.validate(row.adjustments);

                                return programTimeRange.valid;
                            })
                            .filter((res) => !res)
                            .length === 0;
                    })
                    .reduce((res, current) => {
                        return res && current;
                    }, true);
            };
        }

        resetResult() {
            this.result = [
                {
                    displayName: 'LABEL_MONDAY',
                    id: TrueWeekdayEnum.Monday,
                    adjustments: this.collectAdjustments(TrueWeekdayEnum.Monday)
                },
                {
                    displayName: 'LABEL_TUESDAY',
                    id: TrueWeekdayEnum.Tuesday,
                    adjustments: this.collectAdjustments(TrueWeekdayEnum.Tuesday)
                },
                {
                    displayName: 'LABEL_WEDNESDAY',
                    id: TrueWeekdayEnum.Wednesday,
                    adjustments: this.collectAdjustments(TrueWeekdayEnum.Wednesday)
                },
                {
                    displayName: 'LABEL_THURSDAY',
                    id: TrueWeekdayEnum.Thursday,
                    adjustments: this.collectAdjustments(TrueWeekdayEnum.Thursday)
                },
                {
                    displayName: 'LABEL_FRIDAY',
                    id: TrueWeekdayEnum.Friday,
                    adjustments: this.collectAdjustments(TrueWeekdayEnum.Friday)
                },
                {
                    displayName: 'LABEL_SATURDAY',
                    id: TrueWeekdayEnum.Saturday,
                    adjustments: this.collectAdjustments(TrueWeekdayEnum.Saturday)
                },
                {
                    displayName: 'LABEL_SUNDAY',
                    id: TrueWeekdayEnum.Sunday,
                    adjustments: this.collectAdjustments(TrueWeekdayEnum.Sunday)
                },
            ];


            this
                .businessInfoService
                .getBusinessInfoPreferences()
                .then((settings) => {
                    // sort the result array according to the business setting start of the week
                    const startOfTheWeek = settings.appointmentBookSettings.startAppointmentBookDayOn;
                    const index = Math.abs(WeekdayNameEnum.Monday - startOfTheWeek);

                    if (index === 0) return;

                    for (let i = 0; i < index; i++) {
                        this.result.push(this.result.shift());
                    }
                });
        }

        collectAdjustments(id: TrueWeekdayEnum) {
            const adjustments: ProgramTimeRange[] = this.model.$viewValue || [];
            const locationAdjustments = adjustments
                .filter((row) => row.dayOfWeek === id && row.locationId === this.identityService.current().locationId);
            const COAdjustments = adjustments
                .filter((row) => row.dayOfWeek === id && !row.locationId);

            if (locationAdjustments.length) {
                return locationAdjustments;
            } else if (!this.identityService.inCentralOfficeMode() && !this.identityService.isSingleLocation())
                return COAdjustments.map(row => {

                    return new ProgramTimeRange({
                        ...row,
                        locationId: this.identityService.current().locationId
                    });
                });
            else {
                return COAdjustments;
            }
        }

        addAdjustment(row: IDayTimeAdjustmentsRow) {
            if (this.disabled) return;

            row.adjustments.push(new ProgramTimeRange({
                dayOfWeek: row.id,
                startTime: new Date(null, null, null, 9),
                endTime: new Date(null, null, null, 18),
                adjustment: 0,
                programAdjustmentOverride: ProgramAdjustmentOverrideEnum.IncreasePercent,
                isNew: true,
				locationId: this.identityService.inCentralOfficeMode() || this.identityService.isSingleLocation()
					? null
					: this.identityService.current().locationId
            }));

            this.updateViewValue();
        }

        onChange() {
            this.model.$validate();
        }

        updateViewValue() {
            this.modelValue.length = 0;
            this.modelValue.push(...this.result.reduce((all, row) => {
                all.push(...row.adjustments);

                return all;
            }, []));

            this.model.$setViewValue(this.modelValue);

            this.model.$validate();
        }
    }

    angular.module('meevo.plugins.yieldManagementProgram')
        .component('ypDayTimeAdjustments', {
            templateUrl: 'app/plugins/yieldManagementProgram/components/day-time-adjustments/day-time-adjustments.html',
            require: {
                model: 'ngModel'
            },
            bindings: {
                disabled: '=ngDisabled',
                modelCreatedInCurrentLocation: '=',
                isOwner: '=?',
                program: '<'
            },
            controller: DayTimeAdjustments
        });
}
